/* Clip-art product page behaviour, on top of ca-builder.js.
 *
 * ca-builder owns the gallery, the options, the variant picker and the line-item
 * properties; this file only adds what the page around it needs:
 *   - the countdown to the end of today and the delivery dates (from section settings)
 *   - the quantity stepper, written into the form's own quantity input
 *   - shipping protection, added as its own cart line when ticked
 *   - Add to cart and Buy now: let the builder validate and write the properties on
 *     submit, then post the form ourselves so protection and quantity go with it.
 */
(function () {
  'use strict';

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  // Is a cart drawer on screen - Kaching Cart's <kaching-cart-drawer>, or the theme's own?
  // A closed one is display:none, hidden, or parked off the right edge.
  function drawerOpen() {
    var els = document.querySelectorAll('kaching-cart-drawer, .kaching-cart__inner, cart-drawer, ' +
      '.m-cart-drawer, [id*="cart-drawer" i], [class*="cart-drawer" i]');
    return Array.prototype.some.call(els, function (e) {
      var st = getComputedStyle(e), r = e.getBoundingClientRect();
      return st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0' &&
        r.width > 200 && r.height > 300 && r.left < window.innerWidth - 50 && r.right > 50;
    });
  }
  function waitForDrawer(ms) {
    var end = Date.now() + ms;
    return (function look() {
      if (drawerOpen()) return Promise.resolve(true);
      if (Date.now() > end) return Promise.resolve(false);
      return sleep(150).then(look);
    })();
  }

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && format) {
      try { return String(Shopify.formatMoney(cents, format)).replace(/<[^>]*>/g, ''); } catch (e) { /* fall through */ }
    }
    return format ? format.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, amount) : '$' + amount;
  }

  function start(root) {
    var form = root.querySelector('[data-ca-form]');
    if (!form) return;
    var moneyFormat = root.getAttribute('data-pdp-money') || '';
    var protectVariant = (root.getAttribute('data-pdp-protect-variant') || '').trim();
    var protectCents = parseInt(root.getAttribute('data-pdp-protect-cents'), 10) || 0;
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    var qtyValue = root.querySelector('[data-pdp-qty-value]');
    var totalEl = root.querySelector('[data-pdp-total]');
    var protectRow = root.querySelector('[data-pdp-protect]');
    var protectBox = root.querySelector('[data-pdp-protect-input]');
    var idInput = root.querySelector('[data-ca-id]');
    var priceEl = root.querySelector('[data-ca-price]');
    var buy = root.querySelector('[data-pdp-buy]');
    var qty = 1, busy = false;

    /* ---- countdown to the end of today ---- */
    var clock = root.querySelector('[data-pdp-countdown]');
    if (clock) {
      var tick = function () {
        var now = new Date(), end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var left = Math.max(0, Math.floor((end - now) / 1000));
        // two digits each, so the clock keeps one width and the price band never re-wraps
        var two = function (n) { return (n < 10 ? '0' : '') + n; };
        clock.textContent = two(Math.floor(left / 3600)) + 'h ' + two(Math.floor((left % 3600) / 60)) + 'm ' + two(left % 60) + 's';
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- delivery dates ---- */
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var days = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
    var num = function (name, fallback) {
      return parseInt(root.getAttribute(name), 10) || fallback;
    };
    // two promises, because the shop has two delivery zones: home, and everywhere else
    var home = { ship: num('data-pdp-ship-days', 4), min: num('data-pdp-deliver-days', 12),
                 max: num('data-pdp-deliver-max', 0) };
    var abroad = { ship: num('data-pdp-intl-ship-days', home.ship),
                   min: num('data-pdp-intl-deliver-days', home.min),
                   max: num('data-pdp-intl-deliver-max', home.max) };
    var country = root.querySelector('[data-pdp-country]');
    var REMEMBER = 'pdpDeliverTo';

    function showDates() {
      var to = country && country.value !== 'home' ? abroad : home;
      var dates = { '0': days(0), ship: days(to.ship), deliver: days(to.min) };
      // a delivery window reads honestly: "Sep 28 - Oct 1", not one date the order may miss
      var deliverText = to.max > to.min ? fmt(dates.deliver) + ' - ' + fmt(days(to.max)) : fmt(dates.deliver);
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-date]'), function (el) {
        var key = el.getAttribute('data-pdp-date');
        if (key === 'deliver') { el.textContent = deliverText; return; }
        var d = dates[key];
        if (d) el.textContent = fmt(d);
      });
      var eta = root.querySelector('[data-pdp-eta]');
      if (eta) eta.textContent = deliverText;
    }

    if (country) {
      try {
        var kept = localStorage.getItem(REMEMBER);
        if (kept) {
          var match = Array.prototype.filter.call(country.options, function (o) { return o.value === kept; })[0];
          if (match) country.value = kept;
        }
      } catch (e) { /* a browser that refuses storage still gets the home promise */ }
      country.addEventListener('change', function () {
        try { localStorage.setItem(REMEMBER, country.value); } catch (e) { }
        showDates();
      });
    }
    showDates();

    /* ---- "More items to consider": pictures load as the rail comes near, never before photo 1 ---- */
    (function rail() {
      var imgs = document.querySelectorAll('.pdp-rail img[data-pdp-src]');
      if (!imgs.length) return;
      var load = function (im) {
        var src = im.getAttribute('data-pdp-src');
        im.removeAttribute('data-pdp-src');
        if (src) im.src = src;
      };
      if (!('IntersectionObserver' in window)) return Array.prototype.forEach.call(imgs, load);
      var io = new IntersectionObserver(function (seen) {
        seen.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
      }, { rootMargin: '300px' });
      Array.prototype.forEach.call(imgs, function (im) { io.observe(im); });
    })();

    /* ---- gallery: "YOURS" in front of the photo thumbnails, as the design has it ---- */
    (function yoursTile() {
      var strip = root.querySelector('.ca-thumbs');
      if (!strip) {
        // the builder is still drawing: catch the strip the moment it lands, before it paints,
        // so the tile never pushes the thumbnails aside
        var stage = root.querySelector('[data-ca-stage]');
        if (!stage || !window.MutationObserver) return setTimeout(yoursTile, 200);
        var wait = new MutationObserver(function () {
          if (root.querySelector('.ca-thumbs')) { wait.disconnect(); yoursTile(); }
        });
        wait.observe(stage, { childList: true, subtree: true });
        return;
      }
      var first = strip.querySelector('.ca-thumb');
      if (!first) return;
      // the section renders the tile with the gallery; an older section does not, and then it
      // is made here as before
      var tile = strip.querySelector('.pdp-yours');
      if (tile && tile.hasAttribute('data-pdp-wired')) return;
      if (!tile) {
        tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'pdp-yours';
        tile.setAttribute('aria-label', 'Your live preview');
        var plaque = document.createElement('span');
        plaque.className = 'pdp-yours-plaque';
        var label = document.createElement('span');
        label.className = 'pdp-yours-label';
        label.textContent = 'YOURS';
        tile.appendChild(plaque);
        tile.appendChild(label);
        var sep = document.createElement('span');
        sep.className = 'pdp-thumb-sep';
        strip.insertBefore(sep, strip.firstChild);
        strip.insertBefore(tile, strip.firstChild);
      }
      tile.setAttribute('data-pdp-wired', '');
      // slide 1 is the photo the live design is laid over, so "YOURS" goes there - and asking
      // for it is asking to see the design, so it is drawn now if it was still waiting
      tile.addEventListener('click', function () {
        if (window.caBuilder && window.caBuilder.wake) window.caBuilder.wake();
        first.click();
      });
      // Write only on a real change: setAttribute records a mutation even when the value is
      // identical, so writing unconditionally inside the observer froze the page the moment
      // a thumbnail changed the slide.
      var sync = function () {
        var want = first.getAttribute('aria-current') === 'true' ? 'true' : 'false';
        if (tile.getAttribute('aria-current') !== want) tile.setAttribute('aria-current', want);
      };
      sync();
      new MutationObserver(sync).observe(strip, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    })();

    /* ---- price, quantity, protection ---- */
    function variantCents() {
      var digits = (priceEl ? priceEl.textContent : '').replace(/[^\d]/g, '');
      return digits ? parseInt(digits, 10) : parseInt(root.getAttribute('data-pdp-price-cents'), 10) || 0;
    }
    /* ---- the crossed-out price: only what Shopify really holds for this variant ---- */
    var wasEl = root.querySelector('[data-pdp-was]');
    var saveEl = root.querySelector('[data-pdp-save]');
    var prod = null;
    try { prod = JSON.parse(root.querySelector('[data-ca-product]').textContent); } catch (e) { /* the band stays as rendered */ }
    function deal() {
      if (!wasEl && !saveEl) return;
      var id = idInput && idInput.value;
      var v = prod && (prod.variants || []).filter(function (x) { return String(x.id) === String(id); })[0];
      var was = v && v.compareAt ? Number(v.compareAt) : 0;
      var now = v ? Number(v.price) : variantCents();
      var on = was > now;
      if (on) {
        if (wasEl) wasEl.textContent = money(was, moneyFormat);
        if (saveEl) saveEl.textContent = 'Save ' + Math.round((was - now) * 100 / was) + '%';
      }
      if (wasEl) wasEl.hidden = !on;
      if (saveEl) saveEl.hidden = !on;
    }

    function refresh() {
      deal();
      if (qtyValue) qtyValue.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (totalEl) {
        var cents = variantCents() * qty + (protectBox && protectBox.checked ? protectCents : 0);
        totalEl.textContent = money(cents, moneyFormat);
      }
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-qty]'), function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(10, qty + (parseInt(b.getAttribute('data-pdp-qty'), 10) || 0)));
        refresh();
      });
    });
    if (protectBox) {
      protectBox.addEventListener('change', function () {
        if (protectRow) protectRow.classList.toggle('on', protectBox.checked);
        refresh();
      });
    }
    // the price changes with the variant; the builder rewrites it
    new MutationObserver(refresh).observe(priceEl, { childList: true, characterData: true, subtree: true });
    refresh();

    /* ---- add to cart / buy now ---- */
    // Driven by our own two buttons, not by the submit event: Minimog handles the click
    // too and adds the line its own way, which skipped the protection line and the
    // redirect. We take the click in the capture phase, ask the builder to validate and
    // write properties[...] with one submit only it sees (stopped before the theme), then
    // post the cart lines ourselves. A submit from anywhere else is left alone.
    var cta = root.querySelector('[data-ca-cta]');

    // Minimog's own handler sits on this very form, so any submit adds the line the theme's
    // way - with the quantity input we keep and the properties the builder just wrote. It
    // cannot be stopped from outside (it was bound first), and adding the line ourselves as
    // well put it in the cart twice. So: let the theme add it, wait for the cart to grow,
    // then add protection and move on.
    function place(where) {
      if (busy) return;
      // the builder writes properties[...] only when every required answer is there
      Array.prototype.forEach.call(form.querySelectorAll('[data-ca-prop]'), function (n) { n.remove(); });
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      if (!form.querySelector('[data-ca-prop]')) return;
      busy = true;

      var count = function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return c.item_count; });
      };
      count().then(function (before) {
        var deadline = Date.now() + 8000;
        return (function again() {
          return sleep(400).then(count).then(function (now) {
            if (now > before) return now;
            if (Date.now() > deadline) throw new Error('the cart did not take this item');
            return again();
          });
        })();
      }).then(function () {
        if (!protectBox || !protectBox.checked || !protectVariant) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(protectVariant), quantity: 1 }] })
        });
      }).then(function () {
        if (where === 'buy') { window.location.href = '/checkout'; return null; }
        // Add to cart stays on the page, as on every other product in the store: the cart drawer
        // the store runs (Kaching Cart, 2026-09) opens by itself once the line is in. Going to
        // /cart as well showed the drawer and then left the page from under it (2026-09-25).
        // Only when no drawer shows up is /cart still the way to see the cart.
        return waitForDrawer(2500).then(function (open) {
          busy = false;
          if (!open) window.location.href = '/cart';
        });
      }).catch(function (e) {
        busy = false;
        var err = root.querySelector('[data-ca-err]');
        if (err) { err.textContent = String((e && e.message) || e); err.hidden = false; }
      });
    }

    // capture, so the theme's own click handler on Add to cart never runs
    function claim(el, where) {
      if (!el) return;
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        place(where);
      }, true);
    }
    claim(cta, 'cart');
    claim(buy, 'buy');
    if (idInput) {
      // a variant change while the page is open keeps the sticky total honest
      new MutationObserver(refresh).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    /* ---- the shopper's design, shown on purpose, never by dragging the gallery ----
     * Measured at phone width on the stores that sell this for a living: Wander Prints slides
     * a separate "Live preview" bar (fixed, ~260px, with + and - zoom) down from the top;
     * macustom and Macorner keep a fixed "Preview" button within reach; none of them moves the
     * gallery image while the shopper scrolls. So the gallery stays put, a clone of the design
     * goes in a bar of its own once there is something of the shopper's to show, and a pill
     * opens it full screen. ca-builder places layers in % and sizes text in cqw, so a clone in
     * a box of the same aspect ratio is faithful at any size.
     */
    (function preview() {
      if (document.querySelector('.pdp-live')) return;
      var main = root.querySelector('.ca-main');
      var panel = root.querySelector('.pdp-personalize');
      var fields = root.querySelector('[data-ca-fields]');
      var slide = main && main.querySelector('.ca-slide');
      // .ca-main is in the HTML now, before the builder has run: wait for its surface, so the
      // ratio read below is the design's and the gallery is lent only once the builder owns it
      var built = main && main.querySelector('.ca-canvas');
      if (!main || !panel || !fields || !slide || !built || !window.matchMedia) return setTimeout(preview, 200);

      var phone = window.matchMedia('(max-width: 959px)');
      var ratio = getComputedStyle(main).aspectRatio;
      var armed = false, dismissed = false, barOn = false, zoom = 1;
      // 'bar': the design slides in while they personalise. 'button': nothing follows them; a
      // Preview button takes them back up to the gallery, the way Macorner and macustom do it.
      var mode = (root.getAttribute('data-pdp-preview') || 'bar').trim() === 'button' ? 'button' : 'bar';

      function make(tag, cls, html) {
        var e = document.createElement(tag);
        e.className = cls;
        if (html) e.innerHTML = html;
        return e;
      }
      // Laid out as Reminiso's "Your creation" panel: an eyebrow, the design in a framed box,
      // and a "Live preview" row under it - pinned under the store header, which stays put
      var bar = make('div', 'pdp-live',
        '<div class="pdp-live-head"><b>Your creation</b><span class="pdp-live-tools">' +
        '<button type="button" data-pdp-zoom="-1" aria-label="Zoom out">&minus;</button>' +
        '<button type="button" data-pdp-zoom="1" aria-label="Zoom in">+</button>' +
        '<button type="button" data-pdp-hide aria-label="Hide the preview">&times;</button>' +
        '</span></div><div class="pdp-live-stage"></div>' +
        '<div class="pdp-live-foot"><span class="pdp-live-dot">Live preview</span>' +
        '<span class="pdp-live-tag">Made by you, for someone special.</span></div>');
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Your creation, live preview');
      var pill = make('button', 'pdp-see', '<span class="pdp-see-eye"></span>' +
        (mode === 'button' ? 'Preview' : 'See your design'));
      pill.type = 'button';
      pill.hidden = true;
      var sheet = make('div', 'pdp-sheet',
        '<div class="pdp-sheet-head"><b>Your design</b>' +
        '<button type="button" data-pdp-close aria-label="Close">&times;</button></div>' +
        '<div class="pdp-sheet-body"><div class="pdp-sheet-stage"></div></div>' +
        '<div class="pdp-sheet-foot"><button type="button" data-pdp-zoom="-1" aria-label="Zoom out">&minus;</button>' +
        '<span data-pdp-zoom-label>100%</span>' +
        '<button type="button" data-pdp-zoom="1" aria-label="Zoom in">+</button></div>');
      sheet.hidden = true;
      // In Preview-button mode nothing floats: the button in the page is the whole offer, and a
      // pill riding the scroll only says the same thing twice. The nodes stay unattached so the
      // code below can still address them.
      (mode === 'button' ? [] : [bar, pill, sheet]).forEach(function (n) { document.body.appendChild(n); });
      bar.querySelector('.pdp-live-stage').style.aspectRatio = ratio;
      sheet.querySelector('.pdp-sheet-stage').style.aspectRatio = ratio;
      // the frame is as tall as a third of the screen allows and never wider than the screen,
      // so a wide design shrinks instead of being cropped by the frame's width
      (function () {
        var b = main.getBoundingClientRect();
        var r = b.width && b.height ? b.width / b.height : 1;
        bar.querySelector('.pdp-live-stage').style.width = 'min(100%, calc(36vh * ' + r.toFixed(4) + '))';
      })();

      /* The store header stays put while the panel is up, the way Reminiso does it: only its
       * logo row (menu, logo, cart) is held - the announcement and search rows would take the
       * room the design needs. Its section keeps the header's height so the page does not jump.
       * A theme without the Litzzy header (.lzh) simply gets the panel at the top edge.
       */
      var header = document.querySelector('.lzh');
      var headerSeat = header && header.parentNode;
      function pinHeader(on) {
        if (!header) return;
        if (on) headerSeat.style.minHeight = headerSeat.offsetHeight + 'px';
        document.documentElement.classList.toggle('pdp-head-pinned', on);
        if (!on) headerSeat.style.minHeight = '';
        placeBar();
      }
      function placeBar() {
        var on = header && document.documentElement.classList.contains('pdp-head-pinned');
        bar.style.top = on ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px' : '';
      }

      function drawn() { var c = main.querySelector('.ca-canvas'); return !!(c && c.children.length); }

      /* The gallery itself is lent to whichever frame is open, and put back afterwards.
       * Copying its markup instead looked right in Chromium and in WebKit here, yet came out
       * as a blank white square on a real iPhone - and a copy can always drift from the live
       * thing. Lending the element cannot: what the page renders is what the frame shows.
       * A spacer keeps the page from jumping while the gallery is away.
       */
      var home = { parent: main.parentNode, next: main.nextSibling };
      var spacer = document.createElement('div');
      spacer.className = 'pdp-gallery-spacer';
      spacer.hidden = true;

      function lend(stage) {
        if (main.parentNode === stage) return;
        spacer.style.height = Math.round(main.getBoundingClientRect().height) + 'px';
        spacer.hidden = false;
        home.parent.insertBefore(spacer, main);
        stage.appendChild(main);
        main.classList.add('pdp-lent');
      }

      function give() {
        if (main.parentNode === home.parent) return;
        if (home.next && home.next.parentNode === home.parent) home.parent.insertBefore(main, home.next);
        else home.parent.insertBefore(main, spacer);
        main.classList.remove('pdp-lent');
        spacer.hidden = true;
        if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
      }

      function show(where) {
        // only one frame at a time can hold the gallery
        lend(where === 'sheet' ? sheet.querySelector('.pdp-sheet-stage') : bar.querySelector('.pdp-live-stage'));
      }
      function setZoom(step) {
        zoom = Math.max(1, Math.min(3, zoom + step * 0.25));
        main.style.transform = zoom === 1 ? '' : 'scale(' + zoom + ')';
        var label = sheet.querySelector('[data-pdp-zoom-label]');
        if (label) label.textContent = Math.round(zoom * 100) + '%';
      }
      document.addEventListener('click', function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        var z = t.closest('[data-pdp-zoom]');
        if (z) return setZoom(parseInt(z.getAttribute('data-pdp-zoom'), 10) || 0);
        if (t.closest('[data-pdp-hide]')) { dismissed = true; update(); return; }
        if (t.closest('[data-pdp-close]')) {
          sheet.hidden = true;
          zoom = 1;
          setZoom(0);
          document.body.classList.remove('pdp-locked');
          give();                                   // the gallery goes back where it belongs
          update();
        }
      });
      // the same act from the floating pill and from the button in the page
      function upToTheDesign() {
        if (window.caBuilder && window.caBuilder.wake) window.caBuilder.wake();
        give();
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        update();
      }
      root.addEventListener('click', function (ev) {
        if (ev.target.closest && ev.target.closest('[data-pdp-preview-up]')) {
          ev.preventDefault();
          upToTheDesign();
        }
      });

      pill.addEventListener('click', function () {
        if (mode === 'button') {
          // take them back up to the design where it lives, rather than covering the page
          upToTheDesign();
          return;
        }
        zoom = 1;
        if (window.caBuilder && window.caBuilder.wake) window.caBuilder.wake();
        sheet.hidden = false;
        show('sheet');
        setZoom(0);
        document.body.classList.add('pdp-locked');
        pill.hidden = true;
      });

      function seat() {
        return (main.parentNode === home.parent ? main : spacer).getBoundingClientRect();
      }
      function wanted() {
        if (mode === 'button') return false;            // nothing follows the shopper in this mode
        if (!armed || dismissed || !phone.matches || !drawn() || !sheet.hidden) return false;
        var box = panel.getBoundingClientRect();
        // the gallery's place on the page has scrolled away, and the shopper is still in the block
        return seat().bottom < 8 && box.top < window.innerHeight - 40 && box.bottom > 80;
      }
      function update() {
        var on = wanted();
        if (on !== barOn) {
          barOn = on;
          bar.classList.toggle('on', on);
          pinHeader(on);
          if (on) show('bar');
          else if (sheet.hidden) give();
        } else if (barOn) {
          placeBar();                                  // the header can change height (menu, rotate)
        }
        // the Preview row appears once there is a design of the shopper's to look at, and it
        // stands in the action bar, so it is in reach however long the option list runs
        var up = root.querySelector('[data-pdp-preview-up]');
        if (up) up.hidden = !(mode === 'button' && armed && drawn());
        var actions = root.querySelector('.pdp-bar');
        if (actions) document.documentElement.style.setProperty('--pdp-bar-h', Math.round(actions.getBoundingClientRect().height) + 'px');
        if (mode === 'button') {
          pill.hidden = true;                          // the button in the bar is the only offer
        } else {
          // and only once the design has scrolled away: offering a way back to something
          // already on the screen is just clutter
          pill.hidden = !(armed && drawn() && phone.matches && !barOn && sheet.hidden && seat().bottom < 8);
        }
      }

      // ?pdpdebug=1 prints what the frame really measured, for a device I cannot open myself
      if (/[?&]pdpdebug=1/.test(location.search)) {
        var note = make('div', 'pdp-debug', '');
        document.body.appendChild(note);
        setInterval(function () {
          var stage = main.parentNode;
          var b = main.getBoundingClientRect();
          var c = main.querySelector('.ca-canvas');
          note.textContent = 'in:' + (stage && stage.className ? String(stage.className).slice(0, 18) : '-') +
            ' main:' + Math.round(b.width) + 'x' + Math.round(b.height) +
            ' layers:' + (c ? c.children.length : 0) +
            ' imgs:' + main.querySelectorAll('img').length +
            ' armed:' + armed + ' bar:' + barOn + ' sheet:' + !sheet.hidden;
        }, 500);
      }

      // Only a real personalisation wakes it: a clip-art chosen, a name typed, a dropdown
      // answered. Choosing the variant (product, colour, size) or just putting the cursor in a
      // field is not personalising, and leaves the page scrolling normally.
      function personalising(ev) {
        var t = ev.target;
        if (!t || !t.closest) return false;
        if (t.closest('[data-value-id]')) return true;                       // a clip-art or swatch
        if (t.tagName === 'SELECT') return !!String(t.value || '').trim();   // a dropdown answered
        if (t.classList && t.classList.contains('ca-input')) return !!String(t.value || '').trim();
        return false;
      }
      ['click', 'input', 'change'].forEach(function (type) {
        fields.addEventListener(type, function (ev) {
          if (!personalising(ev)) return;
          // whatever this page counts as personalising also wakes a design that was waiting
          if (window.caBuilder && window.caBuilder.wake) window.caBuilder.wake();
          armed = true;
          dismissed = false;
          update();
        }, true);
      });
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();
  }

  function boot() {
    var root = document.querySelector('.ca-pdp[data-ca]');
    if (!root) return;
    var tries = 0;
    (function wait() {
      if (root.querySelector('[data-ca-price]') && root.querySelector('[data-ca-form]')) return start(root);
      if (++tries < 200) setTimeout(wait, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
